<script setup>
const { setupMobileGridFilters } = useCourseData();
const { searchLocationFilter } = useLocationData();
const props = defineProps({
  options: Object,
  total: Number
})

const filtersUnordered = []

if (props.options.ageFilter && props.options.ageFilter.display) {
  const filter = setupMobileGridFilters('ages', props.options.ageFilter)
  filtersUnordered.push(filter)
}

if (props.options.interestFilter && props.options.interestFilter.display) {
  const filter = setupMobileGridFilters('interests', props.options.interestFilter)
  filtersUnordered.push(filter)
}

if (props.options.programsFilter !== null && props.options.programsFilter.display) {
  const filter = setupMobileGridFilters('programs', props.options.programsFilter)
  filtersUnordered.push(filter)
}

if (props.options.formatFilter && props.options.formatFilter.display) {
  const filter = setupMobileGridFilters('format', props.options.formatFilter)
  filtersUnordered.push(filter)
}

if (props.options.locationFilter && props.options.locationFilter.display) {
  const filter = {
    id: 'location',    
    placeholder: props.options.locationFilter.placeholder,
    sortOrder: props.options.locationFilter.sortOrder,
    order: props.options.locationFilter.sortOrder,
  }
  filtersUnordered.push(filter)
}

const filters = filtersUnordered.sort((a, b) => {
  return a.order - b.order;
})
const emit = defineEmits(['onFiltersChanged'])

const filterRefs = ref()

const location = ref();
const sticky = ref(false)
const observer = ref({})
const locationReset = ref(false)
const { $offcanvas } = useNuxtApp();
const bsOffcanvas = ref(), windowWidth = ref(), locationFilterValue = ref('');
const promoBanner = ref(true), showLocation = ref(true), locationCatalog = ref(props.options.locationFilter && props.options.locationFilter.display);

const filterLoc = locationCatalog.value ? {
  id: `location-${props.options.locationFilter.sortOrder}`,
  title: props.options.locationFilter.name,
  mobileTitle: props.options.locationFilter.name,
  placeholder: props.options.locationFilter.placeholder,
  mobilePlaceholder: props.options.locationFilter.placeholder,
  value: [],
  order: props.options.locationFilter.sortOrder,
  type: 'location',
  search: props.options.locationFilter.selected
} : null;
const locationFilter = ref(filterLoc)

const handleClick = () => {
  bsOffcanvas.value.show();
}

onMounted(() => {
  const myOffcanvas = document.getElementById('mobileCourseGridFilter')
  bsOffcanvas.value = new $offcanvas(myOffcanvas)
  promoBanner.value = document.getElementById('promo-banner')

  myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
  })

  observeFilter()

  windowWidth.value = window.innerWidth
  window.addEventListener('resize', function () {
    windowWidth.value = window.innerWidth
  })

})

const observeFilter = () => {
  const filterSection = document.getElementById('grid-mobile-filter');
  let sectionAbove = filterSection.parentElement.parentElement.previousElementSibling
    
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      sticky.value = !entry.isIntersecting;
    })
  });
  
  if (sectionAbove) {
    observer.value.observe(sectionAbove);
  }
  else {
    sticky.value = false;
  }
}

const filterClass = computed(() => {
  return {
    'sticky': sticky.value
  }
})

const applyChanges = ref(false)
const applySelection = () => {
  // applyChanges.value = true;
  filterRefs.value.forEach((filter) => {
    filter.handleSelection()
  })

  if (location.value && location.value.length > 0 && locationReset.value) {
    handleSelection({filter: {type: 'location'}, value: ''})   
  }
  
  scrollToFilter()
  bsOffcanvas.value.hide()
  // applyChanges.value = false;
}

const handleSelection = (field) => {
  let value = field.value
  if (field.filter.type === 'ages') {
    value = field.value.map((v) => {
      return v.replace('Ages ', '')
    })
  }
  else if (field.filter.type === 'format') {
    showLocation.value = true
    if (field.value.length > 1) {
      value = 'All'
    }
    else {
      value = field.value[0]
      if (value === 'Online') {
        showLocation.value = false;
      }
    }
  }
  else if (field.filter.type === 'location' && field.value !== '') {
    locationReset.value = false
  }  
  
  emit('onFiltersChanged', {
    name: field.filter.type,
    value: value
  })
  
}

const scrollToFilter = () => {
  const element = document.getElementById("course-grid-container");
  
  const mobileOffset = windowWidth.value < 768 ? 15 : 0
  const offset = (promoBanner.value ? 103 : 68) + mobileOffset;

  window.scrollTo({
    behavior: 'smooth',
    top:
      document.getElementById("course-grid-container").parentElement.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  })
}

const handleMobileReset = () => {
  filterRefs.value.forEach((filter) => {
    filter.reset()
  })

  if (location.value.length > 0) {
    location.value[0].reset()
    locationReset.value = true;
    handleSelection({filter: {type: 'location'}, value: ''})
  }
  
}
</script>

<template>
  <div class="filter-courses-mobile d-block d-xl-none" :class="filterClass" id="grid-mobile-filter">
    <div class="container">
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-secondary"  id="mobile-filter" @click="handleClick">
            <i class="icon-filter"></i>
            <span class="d-inline-block ms-2">Filter Courses</span>
          </button>
          <p v-if="total > 0" class="text-center text-xl-start ms-xl-3 mt-3 d-none results mb-0">Results: <span class="fw-bold">{{ total }} courses</span></p>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas offcanvas-start  w-100 h-100 d-xl-none p-0" id="mobileCourseGridFilter" tabindex="-1"  aria-labelledby="offcanvasLabel">
    <div class="offcanvas-header">
      <h2 class="offcanvas-title" id="offcanvasLabel">Course filters</h2>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body" id="grid-canvas-body">
      <template v-for="filter in filters" :key="filter.id">
        <FilterCardProductMobileFilter ref="filterRefs" :key="filter.id" :filter="filter" @onSelection="handleSelection" :updateOnSelection="true" v-if="filter.id !== 'location'" :selected="filter.selected" />      
        <FilterCardProductMobileFilter ref="location" :key="filter.id" :filter="locationFilter" @onSelection="handleSelection" v-if="showLocation && locationCatalog && filter.id === 'location'" :locationSearchFilter="true" :selected="locationFilter.selected" />
      </template>
      
    </div>
    <div class="offcanvas-footer p-2">
      <div class="row">
        <div class="col-12 text-center mb-2">
          <span>Results: <b>{{ total }} courses</b></span>
        </div>
        <div class="col-6">
          <button class="btn btn-primary w-100" @click="applySelection" type="button">Apply</button>
        </div>
        <div class="col-6">
          <button class="btn btn-outline-primary w-100" @click="handleMobileReset" type="button">Reset</button>
        </div>
      </div>
      
      
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filter-courses-mobile {
  &.sticky {
    z-index: 990;
    position: fixed;
    left: 0px;
    background-color: $color-secondary;
    padding: 20px 0px 10px;
    .btn {
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);  
      padding: 8px 20px;
    }
    .results {
      display: block !important;      
    }
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    top: 60px;
  }
  width: 100%;
  
}

#mobileCourseGridFilter {
  max-width: 500px;
  .offcanvas-header {
    box-shadow: 0 4px 24px #00000029;
    z-index: 999;
  }

  .offcanvas-footer {
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
    z-index: 999;
  }

  #location {
    .form-floating > .form-control {
      border-radius: 27.5px;
    }
  }
}

</style>

<style lang="scss">
#mobileCourseGridFilter {
  
  #location {
    .form-floating > .form-control {
      border-radius: 27.5px;
    }
  }
}
</style>